import { MakeRoutesOpts } from "common/router/utils/routes";
import { MakePaths } from "common/router/types";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

import { AppointmentBookingStep, AppointmentConfirmationSearch } from "../types";

const paths = {
  confirm: "/appointment/confirmation",
  book: "/appointment/book/:step",
  bookConfirm: "/appointment/book-confirmation",
};

type BookingParams = {
  step: AppointmentBookingStep;
};

type BookingSearch = {
  appointment_ids?: string; // number[]
  is_expired?: boolean;
};

type BookingConfirmSearch = {
  appointment_ids: string;
};

type SchedulerPathDefinitions = {
  confirm: { Search: AppointmentConfirmationSearch };
  book: { Params: BookingParams; Search: BookingSearch };
  bookConfirm: { Search: BookingConfirmSearch };
};

export type SchedulerPaths = MakePaths<SchedulerPathDefinitions>;

export const useSchedulerRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.confirm,
      element: () => import("../components/AppointmentConfirmationPage"),
      pageName: "appointment_confirmation",
    },
    {
      path: paths.book,
      element: () => import("../components/AppointmentBooking"),
      pageName: (params) => `appointment_booking_${params.step}`,
    },
    {
      path: paths.bookConfirm,
      element: () => import("../components/AppointmentBookingConfirm"),
      pageName: "appointment_booking_confirm",
    },
  ]);
};

export const makeSchedulerUrls = (base: string) => {
  return makeUrls<SchedulerPathDefinitions>(base, {
    confirm: { path: paths.confirm },
    book: {
      path: paths.book,
      to: ({ step }) => `/appointment/book/${step}/`,
    },
    bookConfirm: {
      path: paths.bookConfirm,
    },
  });
};
